'use client';
import Image from 'next/image';

// Define your media partners here
const mediaPartners = [
  {
    alt: "cryptonewsz",
    src: "/images/cryptonewsz.webp",
    href: "https://www.cryptonewsz.com/",
    width: 160,
    height: 66,
    },
    {
    alt: "namecoinnews",
    src: "/images/namecoinnews.webp",
    href: "https://www.namecoinnews.com/",
    width: 160,
    height: 66,
    },
    {
    alt: "Times-OF-Blockchain",
    src: "/images/timeofblockchain.webp",
    href: "https://www.timesofblockchain.com/",
    width: 160,
    height: 66,
    },
    {
    alt: "timesofai",
    src: "/images/timesofai_.webp",
    href: "https://www.timesofai.com/",
    width: 160,
    height: 66,
    },
    {
      alt: "Coinnewsspan",
      src: "/images/coinnewsspan-new.svg",
      href: "https://www.coinnewsspan.com/",
      width: 160,
      height: 66,
    },
    {
      alt: "cryptomoonpress-logo",
      src: "/images/cryptomoonpress-logo.webp",
      href: "https://cryptomoonpress.com/",
      width: 160,
      height: 66,
    },
    {
      alt: "capitalbay-logo.webp",
      src: "/images/capitalbay-logo.webp",
      href: "https://www.capitalbay.news/",
      width: 160,
      height: 66,
    },
  {
    src: '/images/all-conference-alert.webp',
    alt: 'all-conference-alert',
    href: 'https://www.allconferencealert.com/',
    width: 122,
    height: 48,
  },
  {
    src: '/images/gtm-labs.webp',
    alt: 'gtm-labs.webp',
    href: 'https://gtmlabs.xyz/',
    width: 160,
    height: 60,
  },
  {
    src: '/images/cryptoJist.webp',
    alt: 'cryptoJist',
    href: 'https://cryptojist.com/',
    width: 160,
    height: 60,
  },
   {
    src: '/images/coin-gabbar.webp',
    alt: 'coin-gabbar',
    href: 'http://www.coingabbar.com/',
    width: 160,
    height: 60,
  },
  {
    src: '/images/ai-time-journal.webp',
    alt: 'aitimejournal',
    href: 'https://www.aitimejournal.com/',
    width: 160,
    height: 60,
  },
  {
    src: '/images/coingape.webp',
    alt: 'coingape',
    href: 'https://coingape.com/',
    width: 160,
    height: 60,
  },
  {
    src: '/images/crypto-news.webp',
    alt: 'crypto-news',
    href: 'https://crypto.news/',
    width: 160,
    height: 60,
  },
  {
    src: '/images/coinpedia-fintech-news-blue-logo.webp',
    alt: 'coinpedia-fintech-news-blue-l0go',
    href: 'https://coinpedia.org/',
    width: 160,
    height: 60,
  },
   {
    src: '/images/the-coin-republic.webp',
    alt: 'the-coin-republic.webp',
    href: 'https://www.thecoinrepublic.com/',
    width: 160,
    height: 60,
  },
   {
    src: '/images/cryptoolitan-logo.webp',
    alt: 'cryptoolitan-logo',
    href: 'https://www.cryptopolitan.com/',
    width: 160,
    height: 60,
  },
   {
    src: '/images/the-cryptonomist-logo.webp',
    alt: 'the-cryptonomist-logo',
    href: 'https://en.cryptonomist.ch/',
    width: 160,
    height: 60,
  },
  {
    src: '/images/blockchainmedia.webp',
    alt: 'blockchainmedia',
    href: 'https://blockchainmedia.id/',
    width: 160,
    height: 60,
  },
   {
    src: '/images/voice-of-crypto.webp',
    alt: 'voice-of-crypto',
    href: 'https://voiceofcrypto.online/',
    width: 160,
    height: 60,
  }, {
    src: '/images/coinroop.webp',
    alt: 'coinroop',
    href: 'https://coinroop.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/coinworldstory-logo.webp',
    alt: 'coinworldstory-logo',
    href: 'https://coinworldstory.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/coinzoba-logo.webp',
    alt: 'coinzoba',
    href: 'https://coinzoba.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/logo-coinkimona.webp',
    alt: 'logo-coinkimona',
    href: 'https://coinkimona.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/lixwe.webp',
    alt: 'LIXWE',
    href: 'https://lixwe.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/altwow.webp',
    alt: 'altwow',
    href: 'https://altwow.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/propfirm-lion.webp',
    alt: 'propfirmlion',
    href: 'https://propfirmlion.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/coinhohe.webp',
    alt: 'coinhohe',
    href: 'https://coinhohe.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/bitcoininsider-logo.webp',
    alt: 'bitcoininsider',
    href: 'https://www.bitcoininsider.org/',
    width: 160,
    height: 60,
  }, {
    src: '/images/coinscapture-logo.webp',
    alt: 'coinscapture-logo',
    href: 'https://coinscapture.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/inbm-logo.webp',
    alt: 'intlbm',
    href: 'https://intlbm.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/cio-review.webp',
    alt: 'cio-review',
    href: 'https://www.cioreview.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/edarabia-logo.webp',
    alt: 'edarabia-logo',
    href: 'https://www.edarabia.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/prtosky-logo.webp',
    alt: 'prtosky-logo',
    href: 'https://prtosky.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/dubai-global-news.webp',
    alt: 'dubai-global-news',
    href: 'https://www.dubaiglobalnews.com/',
    width: 160,
    height: 60,
  },{
    src: '/images/gogetgpt-logo.svg',
    alt: 'gogetgpt-logo',
    href: 'https://gogetgpt.com/',
    width: 160,
    height: 60,
  }, {
    src: '/images/tredu-logo-new.svg',
    alt: 'Tredu-logo',
    href: 'http://tredu.com',
    width: 160,
    height: 60,
  },
  {
    src: '/images/3versetv.webp',
    alt: '3versetv',
    href: 'https://www.3versetv.com/',
    width: 160,
    height: 60,
  },
  {
    src: '/images/zexprwire-logo.webp',
    alt: 'zexpr',
    href: 'https://zexprwire.com/',
    width: 160,
    height: 60,
  },
   {
    src: '/images/blockchain-reporter.webp',
    alt: 'blockchain-reporter',
    href: 'https://blockchainreporter.net/',
    width: 160,
    height: 60,
  },
  {
    src: '/images/cryptoken-media.webp',
    alt: 'cryptoken-media',
    href: 'https://cryptoken.media',
    width: 160,
    height: 60,
  },
  {
    src: '/images/cryptobrowser.webp',
    alt: 'cryptobrowser',
    href: 'https://cryptobrowser.io/',
    width: 160,
    height: 60,
  },
  {
    src: '/images/financialservicesreview.webp',
    alt: 'financialservicesreview',
    href: 'https://www.financialservicesreview.com/',
    width: 160,
    height: 60,
  },
  {
    src: '/images/industryevents.webp',
    alt: 'industryevents',
    href: 'https://www.industryevents.com/',
    width: 160,
    height: 60,
  },{
    src: '/images/tmp-logo.webp',
    alt: 'tmp-logo',
    href: 'https://www.thecoinrepublic.com/',
    width: 160,
    height: 60,
  },
  {
    src: '/images/alhuda_logo.webp',
    alt: 'alhuda',
    href: 'https://www.alhudacibe.com/',
    width: 160,
    height: 60,
  },

 {
  src: '/images/cryptonewss.webp',
  alt: 'CryptosNewss',
  href: 'https://cryptosnewss.com/',
  width: 148,
  height: 58,
},
{
  src: '/images/cryptonews.webp',
  alt: 'CryptoNews',
  href: 'https://cryptonews.com/',
  width: 148,
  height: 58,
},
{
  src: '/images/affmaven.webp',
  alt: 'AFFMaven',
  href: 'https://affmaven.com/',
  width: 148,
  height: 58,
},
{
  src: '/images/bitcoinworld.webp',
  alt: 'Bitcoin-World',
  href: 'https://bitcoinworld.co.in/',
  width: 148,
  height: 58,
},
{
  src: '/images/indnewswire.webp',
  alt: 'IndNewsWire',
  href: 'https://indnewswire.com/',
  width: 148,
  height: 58,
},
{
  src: '/images/droomblack.webp',
  alt: 'DroomDroom-Black',
  href: 'https://droomdroom.com/',
  width: 148,
  height: 58,
},
{
  src: '/images/web3africa.webp',
  alt: 'Web3Africa',
  href: 'https://web3africa.tech/',
  width: 148,
  height: 58,
},
{
  src: '/images/blockchainreporter.webp',
  alt: 'blockchainreporter',
  href: 'https://blockchainreporter.net/',
  width: 148,
  height: 58,
},
{
  src: '/images/theblockopedia-new.webp',
  alt: 'theblockopedia-new',
  href: 'https://theblockopedia.com/',
  width: 148,
  height: 58,
},
{
  src: '/images/startupnews-logo.webp',
  alt: 'startupnews',
  href: 'https://startupnews.fyi/',
  width: 148,
  height: 58,
},
{
  src: '/images/games-3s-logo.webp', 
  atl: 'game-3s-white', 
  href: 'https://www.games.gg/',
  width: 148,
  height: 58,
},
{
  src: '/images/invest24-logo.webp', 
  atl: 'invest24-logo', 
  href: 'https://www.invest24.uz/',
  width: 148,
  height: 58,
},
{
  src: '/images/blockchain-texno.webp',
  atl: 'blockchain-texno', 
  href: 'https://www.blockchaintexno.uz/',
  width: 148,
  height: 58,
},
{
  src: '/images/tredu-logopr.svg', 
  atl: 'tredu-logo', 
  href: 'https://www.tredu.com/',
  width: 148,
  height: 58,
},

{
  src: '/images/bitcoin-com.webp', 
  atl: 'bitcoin-com', 
  href: 'https://www.bitcoin.com/',
  width: 148,
  height: 58,
},
  
];


const MediaPartnersSection = () => {
  return (
    <section data-component-id="src/app/MediaPartnersSection.tsx:423:4" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="423" data-component-file="MediaPartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners%22%2C%22className%22%3A%22w-full%20max-w-%5B1240px%5D%20mx-auto%20px-%5B20px%5D%20sm%3Apx-%5B40px%5D%20lg%3Apx-%5B56px%5D%20mt-%5B66px%5D%22%7D"
      id="partners"
      className="w-full max-w-[1240px] mx-auto px-[20px] sm:px-[40px] lg:px-[56px] mt-[66px]"
    >
      <div data-component-id="src/app/MediaPartnersSection.tsx:427:6" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="427" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-%5B60px%5D%20items-center%20w-full%22%7D" className="flex flex-col gap-[60px] items-center w-full">
        {/* Section Title */}
        <h2 data-component-id="src/app/MediaPartnersSection.tsx:429:8" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="429" data-component-file="MediaPartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B28px%5D%20sm%3Atext-%5B36px%5D%20md%3Atext-%5B46px%5D%20lg%3Atext-%5B56px%5D%20font-satoshi%20font-bold%20leading-tight%20text-center%20bg-%5Blinear-gradient(175deg%2C%23000000_0%25%2C_%232626267f_100%25)%5D%20bg-clip-text%20text-transparent%22%2C%22textContent%22%3A%22Past%20Media%20Partners%22%7D" className="text-[28px] sm:text-[36px] md:text-[46px] lg:text-[56px] font-satoshi font-bold leading-tight text-center bg-[linear-gradient(175deg,#000000_0%,_#2626267f_100%)] bg-clip-text text-transparent">
          Past Media Partners
        </h2>

        {/* Grid of Media Partners */}
        <div data-component-id="src/app/MediaPartnersSection.tsx:434:8" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="434" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-6%20gap-y-%5B14px%5D%20gap-x-%5B32px%5D%20w-full%20justify-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-y-[14px] gap-x-[32px] w-full justify-items-center">
          {mediaPartners.map((partner, index) => (
            <a data-component-id="src/app/MediaPartnersSection.tsx:436:12" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="436" data-component-file="MediaPartnersSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20h-%5B70px%5D%20border-2%20border-%5B%23ff00b6%5D%20rounded-%5B10px%5D%20p-5%22%7D"
              key={index}
              href={partner.href}
              target="_blank"
              rel={index === 0 ? "noopener noreferrer" : "noopener noreferrer nofollow"}
              className="flex items-center justify-center h-[70px] border-2 border-[#ff00b6] rounded-[10px] p-5"
            >
              <Image data-component-id="src/app/MediaPartnersSection.tsx:443:14" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="443" data-component-file="MediaPartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20w-%5B260px%5D%20h-%5B60px%5D%22%7D"
                src={partner.src}
                alt={partner.alt}
                width={partner.width}
                height={partner.height}
                className="object-contain w-[260px] h-[60px]"
                unoptimized
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MediaPartnersSection;
